import { Box } from "@material-ui/core";

import { useStyles } from "./SlideWrapper.style";

export const SlideWrapper = (props: any) => {
  const classes = useStyles(props);

  return <Box className={classes.root}>{props.children}</Box>;
};
